import React, { useState, useEffect } from 'react';
import SvgComponent from '../../../common/components/SvgComponent/SvgComponent';
import whatsApp_icon from '../../../images/icons/whatsApp_icon.svg';
import missedCall from '../../../images/icons/CallLogsIcons/missedCall.svg';
import styles from './style.module.css';
import moment from 'moment';
import { navigate } from 'gatsby';
import {
  getApplicantionInfo,
  setApplicantionInfo
} from '../../../common/utils/applicantionInfo';
import PopUp from '../../../common/components/PopUp/PopUp';
import {
  notificationAsReadAPI,
  getCustomerDetails,
  getProfessionType
} from '../../constants/api';
import { getFiltersInfo, setFiltersInfo } from '../../utils/FiltersInfo';

const NotificationInfo = ({ each, setNotification, allread }) => {
  const { notification_info_container } = styles;
  const [showMore, setShowMore] = useState(false);
  const [type, setType] = useState('loading');
  const [text, setText] = useState('Loading...');
  const [show, setShow] = useState(false);
  const [leadData, setLeadData] = useState({});

  let msg = each?.metaData?.whatsappMessage;

  function showMoreFun(e) {
    e.stopPropagation();
    setShowMore(true);
  }

  function markAsReadNotificationFun() {
    return notificationAsReadAPI(each?.notificationId)
      .then(res => {
        setShow(false);
      })
      .catch(error => {
        setShow(false);
      });
  }

  function getLeadData() {
    return getCustomerDetails(each?.metaData?.leadId)
      .then(res => {
        return res;
      })
      .catch(error => {});
  }
  function getApplicantData() {
    return getProfessionType(
      each?.metaData?.leadId,
      each?.metaData?.applicantId
    )
      .then(res => {
        return res;
      })
      .catch(error => {});
  }

  return (
    <>
      <div
        className="relative cursor-pointer"
        onClick={async () => {
          setType('loading');
          setText('loading...');
          setShow(true);
          let leadDt = await getLeadData();
          let applicantData = await getApplicantData();
          await markAsReadNotificationFun();
          setShow(false);

          setNotification(false);
          setApplicantionInfo({
            applicationStatus: leadDt?.status,
            leadId: each?.metaData?.leadId,
            leadApplicantId: each?.metaData?.applicantId,
            showWhatsApp:
              each?.messageType == 'APPLICANT_WHATSAPP_RM' ? true : false,
            applicantInfo: {
              id: each?.metaData?.applicantId,
              mainApplicant:
                applicantData?.applicantType == 'MAIN_APPLICANT' ? true : false
            },
            leadData: {
              loanAmount: leadDt?.loanAmount,
              loanProduct: leadDt?.productName
            }
          });
          if (
            each?.messageType == 'APPLICANT_WHATSAPP_RM' ||
            each?.messageType?.includes('WHATSAPP')
          ) {
            if (window.location.pathname === '/app/whatsapp') {
              return window.location.reload();
            }
            navigate('/app/whatsapp');
          } else if (each?.messageType == 'LEAD_MISSED_CALL') {
            let callType = 'no-answer';

            setFiltersInfo({
              ...(getFiltersInfo() || {}),
              callLogs: {
                callMade: {
                  startDate: each?.createdAt,
                  toDate: each?.createdAt
                },
                callType: {
                  [callType]: {
                    name: callType,
                    key: callType,
                    status: callType && true
                  }
                }
              }
            });

            if (window.location.pathname.match(/\/app\/calllog\/[0-9]/)) {
              return window.location.replace(
                `/app/calllog/${each?.metaData?.leadId}`
              );
            }
            navigate(`/app/calllog/${each?.metaData?.leadId}`);
          }
        }}
      >
        <div
          className={` ${notification_info_container} bg-navy-600 p-2 rounded-md flex items-center m-3 `}
        >
          <div className="bg-white h-12 w-12 border border-grey-300 flex items-center justify-center rounded-full">
            <SvgComponent
              img={
                each?.messageType === 'APPLICANT_WHATSAPP_RM'
                  ? whatsApp_icon
                  : each?.messageType === 'LEAD_MISSED_CALL'
                  ? missedCall
                  : ''
              }
              className="text-green-paleGreen"
            />
          </div>
          <div>
            <div> {each?.metaData?.message || ''}</div>

            <div>
              {!showMore && msg?.length > 50 && (
                <>
                  <span>{msg?.slice(0, 50)}</span>
                  <span className="text-2xl font-bold" onClick={showMoreFun}>
                    ...
                  </span>
                </>
              )}
              {!showMore && msg?.length < 50 && msg}

              {showMore && msg}
            </div>
          </div>
          {!allread && !each?.viewedAt && (
            <div
              style={{
                left: '50px'
              }}
              className="h-2 w-2 relative rounded-full bg-red-400"
            ></div>
          )}
        </div>
        <div
          className="absolute text-xs font-bold"
          style={{
            bottom: '1px',
            right: '20px'
          }}
        >
          <div className="relative">
            <div>{moment(each?.createdAt).format('MMM D, YYYY') || 'NA'}</div>
            <div>{moment(each?.createdAt).format('hh:mm A') || ''}</div>
          </div>
          {each?.metaData?.isDocumentSent && <div>Sent the doc</div>}
        </div>
      </div>
      <PopUp type={type} text={text} show={show} setShow={setShow} />
    </>
  );
};

export default NotificationInfo;
